import { types as actions } from '../actions';
const defaultState = {
  orgCount: null,
  currentOrg: null
};

export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case actions.SET_ORGS:
      return {
        ...state,
        orgs : action.orgs,
        orgCount : action.orgCount
      }
    case actions.SET_ORG:
      return {
        ...state,
        currentOrg: action.org
      }
    case actions.SET_ORG_USER_ROLE:
      return {
        ...state,
        orgUserRole : action.orgUserRole.response.assetInfo.metadata.props.role.toLowerCase()
      }
    case actions.LOGGED_OUT:
      return defaultState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/organizations/index.js